import React from 'react'
import {faFileCircleCheck} from '@fortawesome/free-solid-svg-icons/faFileCircleCheck'
import {FontAwesomeIcon, FontAwesomeIconProps} from '@fortawesome/react-fontawesome'

type MemberFileCircleCheckIconProps = Pick<FontAwesomeIconProps, 'color'>

export const MemberFileCircleCheckIcon: React.VFC<MemberFileCircleCheckIconProps> = ({color}) => {
  return <FontAwesomeIcon icon={faFileCircleCheck} size={'2x'} color={color}/>
}
